<template>
    <div class="invalid-goods-slide" ref="slideWrapper">
        <div class="invalid-goods-item" @click="event_toProductDetail">
            <div class="select-btn" ref="selectBtn">
                <i class="iconfont icon-bukexuan"></i>
            </div>
            <div class="goods-img">
                <img :src='image'>
                <div class="img-bg"></div>
                <p class="invalid-tip" v-if="productInfo.inventoryStatus === 2">售罄</p>
            </div>
            <div class="goods-info">
                <p class="brand-name">{{productInfo.brandEnName}}/{{productInfo.brandChName}}</p>
                <p class="goods-name">{{productInfo.name}}</p>
                <p class="goods-spec">
                    <span v-if="productInfo.color">颜色: {{productInfo.color}}</span>
                    <span v-if="productInfo.size">尺码: {{productInfo.size}}</span>
                </p>
                <div class="price-info">
                    <div class="goods-price">
                        <span class="integer">￥{{productInfo.nowPrice}}</span>
                    </div>
                    <div class="look-for-similar">
                        找相似
                    </div>
                </div>
            </div>
            <div class="right-btns" ref="rightBtns">
                <!--M站不做收藏功能-->
                <!--<div @click.stop="event_addToFavorite" class="collect-btn">移入<br />收藏</div>-->
                <div @click.stop="event_delete" class="delete-btn">删除</div>
            </div>
        </div>
        <div class="bottom-line"></div>
    </div>
</template>

<script>
    import BScroll from 'better-scroll';

    import {api_deleteProduct} from '@/api';

    import {handleResCartData} from '@/public/js/public.js';

    const SEC = require('common/js/utils/core.js');

    export default {
        name: '',
        props: {
            productInfo: {
                type: Object,
                default: {}
            }
        },
        data () {
            return {
                scroll: null
            };
        },
        computed: {
            // 加工图片
            image () {
                const {image} = this.productInfo;
                return image && `//pic.secoo.com/product/240/240/${image}`;
            },
            // 对价格进行加工
            currencyPrice () {
                const {secooPrice} = this.productInfo;
                const reg = /\./;
                let currencyPrice = reg.test(secooPrice)
                    ? SEC.number.currency(secooPrice, 2)
                    : SEC.number.currency(secooPrice);
                return currencyPrice;
            }
        },
        mounted () {
            const _this = this;
            // 初始化scroll
            _this.scroll = new BScroll(_this.$refs.slideWrapper, {
                scrollX: true, // 开启横向滚动
                // bounce当滚动超过边缘的时候会有一小段回弹动画。设置为 true 则开启动画。
                bounce: {
                    top: false,
                    bottom: false,
                    left: false,
                    right: false
                },
                // momentum:当快速在屏幕上滑动一段距离的时候，会根据滑动的距离和时间计算出动量，并生成滚动动画。设置为 true 则开启动画。
                momentum: false

            });
            // 监听滚动结束的事件获取滚动方向
            _this.scroll.on('scrollEnd', function () {
                const direction = _this.scroll.directionX;
                if (direction === 1) { // 从左向右滑
                    // 显示右侧的移入收藏和删除按钮
                    _this.scroll.scrollToElement(_this.$refs.rightBtns, 200);
                } else if (direction === -1) {
                    // 隐藏右侧的移入收藏和删除按钮
                    _this.scroll.scrollToElement(_this.$refs.selectBtn, 200);
                }
                // alert(_this.scroll.movingDirectionY);
            });
        },
        methods: {
            // 跳转商品详情页
            event_toProductDetail () {
                const {productId} = this.productInfo;
                window.location.href = `//m.secoo.com/proDetail.html?prodId=${productId}`;
            },
            // 删除商品
            event_delete () {
                const _this = this;
                const {itemKey} = _this.productInfo;
                api_deleteProduct(itemKey).then(({data}) => {
                    const {retCode, cart} = data;

                    if (retCode === 0) {
                        // 处理返回数据
                        handleResCartData(cart);
                    }
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    .invalid-goods-slide:last-child .bottom-line{
        background-color: red;
        display: none;
    }
    .invalid-goods-item {
        @extend %flex-horizontal;
        @include box-align(center);
        flex-wrap: nowrap;
        width: toRem(880);
        height: toRem(320);
        background-color: $color-white;
        /*box-shadow: 0 1px 0 0 #E1E1E1;*/
        .select-btn {
            @extend %flex-horizontal;
            @include box-align(center);
            @include box-pack(center);
            width: toRem(80);
            height: 100%;
            line-height: toRem(320);
            .iconfont {
                font-size: toRem(34);
                color: #999;
            }
        }
        .goods-img {
            position: relative;
            width: toRem(220);
            height: toRem(220);
            margin-right: toRem(20);
            img {
                width: 100%;
                height: 100%;
            }
            .img-bg {
                width: 100%;
                height: 100%;
                position: absolute;
                left: 0;
                top: 0;
                background-color: $color-black;
                opacity: 0.04;
            }
            .invalid-tip {
                position: absolute;
                left: 50%;
                top: 50%;
                width: toRem(90);
                height: toRem(60);
                margin-left: toRem(-45);
                margin-top: toRem(-30);
                background-color: $color-black;
                opacity: 0.8;
                font-family: PingFangSC-Medium;
                font-size: toRem(26);
                color: #FFFFFF;
                text-align: center;
                line-height: toRem(60);
            }
        }
        .goods-info {
            width: toRem(430);
            height: toRem(220);
            color: $color-black;
            .brand-name, .goods-name, .goods-spec {
                width: 100%;
                height: toRem(37);
                line-height: toRem(37);
                font-size: toRem(26);
                overflow: hidden;
                color: #999;
                @extend %text-ellipsis;
            }
            .brand-name {
                font-family: Futura-Medium;
            }
            .goods-name, .goods-spec {
                font-family: FuturaLT-Light;
            }
            .goods-spec {
                margin-bottom: toRem(52);
            }
            .goods-spec span:first-child {
                margin-right: toRem(40);
            }
            .price-info {
                @include box-align(center);
                @extend %flex-horizontal-between;
                .goods-price {
                    flex: 1;
                    height: toRem(48);
                    line-height: toRem(48);
                    font-size: toRem(34);
                    font-family: Futura-Medium;
                    color: #999;
                    overflow: hidden;
                    @extend %text-ellipsis;
                    .decimal {
                        font-size: toRem(22);
                    }
                }
                .look-for-similar {
                    display: none;
                    height: toRem(60);
                    line-height: toRem(60);
                    width: toRem(160);
                    padding: 0 toRem(10);
                    margin-right: toRem(30);
                    /*border: 1px solid #202123;*/
                    color: #202123;
                    text-align: center;
                    font-size: toRem(26);
                    font-family: PingFangSC-Medium;
                    @include box-sizing(border-box);
                    @include border-1px(#202123);
                }
            }
        }
        .right-btns {
            height: 100%;
            width: toRem(130);
            @extend %flex-horizontal;
            .delete-btn {
                @extend %flex-horizontal;
                @include box-align(center);
                @include box-pack(center);
                width: toRem(130);
                height: 100%;
                line-height: toRem(33);
                font-family: PingFangSC-Medium;
                font-size: toRem(24);
                color: #FFF;
                background-color: $color-black;
            }
        }
    }
    .bottom-line {
        width: toRem(690);
        margin: 0 auto;
        @include border-1px-b($color-gray);
    }
</style>



// WEBPACK FOOTER //
// src/components/InvalidGoodsItem/index.vue